import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useCurrency, formatCurrency } from '../../../utils/currency';

export default function RevenueSummary({ data }) {
    const navigate = useNavigate();
    const { currency } = useCurrency();

    // Extract actual API data with zero-safe defaults
    const today = data?.today !== undefined && data?.today !== null ? Number(data.today) : 0;
    const todayTrend = data?.todayTrend !== undefined && data?.todayTrend !== null ? Number(data.todayTrend) : 0;
    const isUp = todayTrend >= 0;
    const monthToDate = data?.monthToDate !== undefined && data?.monthToDate !== null ? Number(data.monthToDate) : 0;
    const outstandingDues = data?.outstandingDues !== undefined && data?.outstandingDues !== null ? Number(data.outstandingDues) : 0;

    return (
        <Card 
            onClick={() => navigate('/finance')}
            sx={{ 
                borderRadius: 3, 
                boxShadow: '0 1px 3px rgba(0,0,0,0.04)', 
                border: '1px solid #f1f5f9',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                cursor: 'pointer',
                transition: 'box-shadow 0.2s',
                '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.06)' }
            }}
        >
            <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
                {/* Top Label & Badge */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                    <Typography 
                        variant="caption" 
                        sx={{ 
                            fontWeight: 700, 
                            letterSpacing: '0.06em', 
                            color: '#94a3b8', 
                            textTransform: 'uppercase',
                            fontSize: '0.72rem'
                        }}
                    >
                        TODAY'S REVENUE
                    </Typography>
                    <Box 
                        sx={{ 
                            bgcolor: isUp ? '#dcfce7' : '#fee2e2', 
                            color: isUp ? '#16a34a' : '#ef4444', 
                            px: 1, 
                            py: 0.25, 
                            borderRadius: '12px',
                            fontSize: '0.72rem',
                            fontWeight: 700,
                            lineHeight: 1.2
                        }}
                    >
                        {isUp ? `+${todayTrend}%` : `${todayTrend}%`}
                    </Box>
                </Box>

                {/* Main Revenue Value & net total */}
                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mb: 2.5 }}>
                    <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', lineHeight: 1.1, fontSize: '1.85rem' }}>
                        {formatCurrency(today, currency)}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#94a3b8', fontSize: '0.78rem' }}>
                        net total
                    </Typography>
                </Box>

                {/* Bottom Row: Month-to-Date Revenue & Unsettled */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', pt: 0.5 }}>
                    <Box>
                        <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.72rem', display: 'block' }}>
                            Month-to-Date Revenue
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 800, color: '#0f172a', fontSize: '0.88rem' }}>
                            {formatCurrency(monthToDate, currency)}
                        </Typography>
                    </Box>

                    <Box sx={{ textAlign: 'right' }}>
                        <Typography variant="body2" sx={{ fontWeight: 800, color: '#ef4444', fontSize: '0.88rem' }}>
                            {formatCurrency(outstandingDues, currency)}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#ef4444', fontSize: '0.72rem', display: 'block' }}>
                            Unsettled
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
}
